<template>
  <main class="main" role="main">
    <header class="header">
      <div class="inner" v-if="isEstimateManage">
        <div class="left">
          <button class="h_btn i_back" @click="$router.go(-1)"></button>
        </div>
        <h1 class="h1">요청서 일괄 전송</h1>
        <div class="right"></div>
      </div>
      <div class="inner" v-else>
        <div class="left">
          <button class="h_btn i_back" @click="goHome"></button>
        </div>
        <h1 class="h1">홈 이동</h1>
        <div class="right"></div>
      </div>
    </header>
    <div class="main_con nodrag">
      <div ref="dummy"></div>
      <div class="store">
        <div class="store_ttl">
          <h1>작성하신 견적요청서를<br />우리동네 매장에게 발송해보세요!</h1>
          <div class="store_ttl_txt">(체크 박스 선택 후 전송하기)</div>
        </div>
        <div class="sort" v-if="headOption.visible">
          <ul>
            <li
              :class="{ on: filter.orderType == 'RECOMMAND_POINT' }"
              @click="closeShopFilterModal('RECOMMAND_POINT')"
            >
              <p>추천 순</p>
            </li>
            <li
              :class="{ on: filter.orderType == 'RESPONSE_RATE' }"
              @click="closeShopFilterModal('RESPONSE_RATE')"
            >
              <p>응답률 순</p>
            </li>
            <li
              :class="{ on: filter.orderType == 'CREATED_AT' }"
              @click="closeShopFilterModal('CREATED_AT')"
            >
              <p>신규매장 순</p>
            </li>
            <li
              :class="{ on: filter.orderType == 'CHAT_COUNT' }"
              @click="closeShopFilterModal('CHAT_COUNT')"
            >
              <p>상담건 순</p>
            </li>
            <li
              :class="{ on: filter.orderType == 'EVALUATION_SCORE' }"
              @click="closeShopFilterModal('EVALUATION_SCORE')"
            >
              <p>평점 순</p>
            </li>
          </ul>
        </div>
        <div class="store_list_wrap" v-if="list.length > 0">
          <div class="store_list" v-for="store in list" :key="store.id">
            <div class="base">
              <div class="list_thumb" @click="goShopDetail(store)">
                <div class="n_thumb">
                  <div class="n_thumb_inner">
                    <img :src="store.storePhoto" alt="" />
                    <div class="sale_inner_bg" v-if="!isSaleEnd(store)">
                      상담종료
                    </div>
                  </div>
                </div>
              </div>
              <div class="store_info">
                <div class="checkbox_red" v-if="isSaleEnd(store)">
                  <input
                    type="checkbox"
                    :id="store.id"
                    v-model="storeId"
                    :value="store.id"
                  />
                  <label :for="store.id"></label>
                </div>
                <div class="ttl" @click="goShopDetail(store)">
                  <h1>{{ store.name }}</h1>
                  <p>{{ store.address }} {{ store.addressDetail }}</p>
                </div>
                <div class="shop_index_wrap" @click="goShopDetail(store)">
                  <div class="shop_index">
                    <dl>
                      <dt><i class="i_chart"></i>응답률</dt>
                      <dd v-if="store.chatCnt > 0 && store.responseRate > 0">
                        {{
                          store.responseRate > 100 ? 100 : store.responseRate
                        }}%
                      </dd>
                      <dd v-else style="padding:0 0.5rem">-</dd>
                      <dd
                        v-if="
                          store.responseMinute >= 0 &&
                            store.responseMinute <= 10 &&
                            store.chatCnt > 0
                        "
                        style="margin-left:0.2rem"
                      >
                        (10분 이내)
                      </dd>
                      <dd
                        v-if="
                          store.responseMinute > 10 &&
                            store.responseMinute <= 30 &&
                            store.chatCnt > 0
                        "
                        style="margin-left:0.2rem"
                      >
                        (30분 이내)
                      </dd>
                      <dd
                        v-if="
                          store.responseMinute > 30 &&
                            store.responseMinute <= 60 &&
                            store.chatCnt > 0
                        "
                        style="margin-left:0.2rem"
                      >
                        (1시간 이내)
                      </dd>
                      <dd
                        v-if="
                          store.responseMinute > 60 &&
                            store.responseMinute <= 120 &&
                            store.chatCnt > 0
                        "
                        style="margin-left:0.2rem"
                      >
                        (2시간 이내)
                      </dd>
                      <dd
                        v-if="
                          store.responseMinute > 120 &&
                            store.responseMinute <= 360 &&
                            store.chatCnt > 0
                        "
                        style="margin-left:0.2rem"
                      >
                        (6시간 이내)
                      </dd>
                      <dd
                        v-if="store.responseMinute > 360 && store.chatCnt > 0"
                        style="margin-left:0.2rem"
                      >
                        (6시간 이상)
                      </dd>
                    </dl>
                  </div>
                  <div class="shop_index">
                    <dl>
                      <dt><i class="i_chat"></i>상담</dt>
                      <dd>{{ store.chatCnt }}건</dd>
                    </dl>
                  </div>
                </div>
              </div>
            </div>
            <p class="add_info_01" v-if="store.info">
              {{ store.info }}
            </p>
            <!-- <div class="add_info_02">
      <ul>
        <li><p># 사전승낙점</p></li>
        <li><p># SKT</p></li>
        <li><p># 친절한 집</p></li>
        <li><p># 알뜰폰</p></li>
      </ul>
    </div> -->
          </div>
        </div>
        <div v-else class="empty_wrap">
          <div class="empty">
            <!--'기본: ', '준비중: ready', '결과없음: result'-->
            <div class="msg">
              <div style="margin-bottom:10px;">
                우리동네에 매장이 없습니다.<br />
                주변 번화가로 동네설정을 변경해보세요.
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="btm_btn">
        <div class="btn_wrap">
          <button class="btn bo" @click="goHome" v-if="!isEstimateManage">
            다음에 하기
          </button>
          <button class="btn" @click="sendEstimation">
            견적 요청하기
          </button>
        </div>
      </div>
      <infinite-loading
        ref="infiniteLoading"
        :direction="direction"
        :identifier="infiniteId"
        @infinite="infiniteHandler"
      >
        <span slot="no-more"></span>
        <span slot="no-results"></span>
        <span slot="spinner"></span>
      </infinite-loading>
    </div>
    <DesignPopup
      @close="confirm"
      :show="designPopup"
      :data="popupParams"
    ></DesignPopup>
  </main>
</template>

<script>
import ShopFilterModal from './modal/ShopFilterModal.vue';
import { mapActions, mapState, mapGetters } from '@common/store/modules/shop';
import * as shopTypes from '@common/store/modules/shop/types';
import { mapGetters as userMapGetters } from '@common/store/modules/user';
import * as userTypes from '@common/store/modules/user/types';

import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';
import { authMapGetters, authGetters } from '@common/store/modules';

import {
  mapActions as chatMapActions,
  mapState as chatMapState,
  mapGetters as chatMapGetters,
} from '@common/store/modules/chat';
import * as chatTypes from '@common/store/modules/chat/types';

import DesignPopup from '@/common/components/modal/DesignPopup.vue';
import InfiniteLoading from 'vue-infinite-loading';
export default {
  components: {
    DesignPopup,
    InfiniteLoading,
  },
  data() {
    return {
      isEstimateManage: this.$route.query.estimateManage || false,
      storeId: [],
      shopFilterModal: false,
      options: {
        // orderType: 'RESPONSE_RATE',
        orderType: 'RECOMMAND_POINT',
      },
      filter: {},
      designPopup: false,
      popupParams: {
        type: 'confirm',
        msg: '',
      },
      fetchCompleted: false,
      direction: 'top',
      infiniteId: 0,
      list: [],
      size: 10,
      page: 1,
      checkStoreId: [],
    };
  },
  beforeCreated() {
    this.filter = this.options;
  },
  computed: {
    ...mapGetters({
      shops: shopTypes.SHOPS,
      shopInfo: shopTypes.SHOP,
      shopCnt: shopTypes.SHOP_COUNT,
    }),
    ...userMapGetters({
      user: userTypes.USER,
    }),
    ...authMapGetters({
      currentUser: authGetters.CURRENT_USER,
    }),
    ...estimateMapGetters({
      autoEstimation: estimationTypes.AUTO_ESTIMATION,
    }),
    headOption() {
      let str = '우리동네 근처에<br />매장이 없습니다.';
      let visible = false;
      if (this.shopCnt > 0 || this.filter.follow || this.filter.keyword) {
        str = '우리동네 매장들과<br />상담을 시작해 보세요!';
        visible = true;
      }
      return { headText: str, visible: visible };
    },
  },
  async mounted() {
    this.filter = this.options;
    //this.getList();
    this.infiniteId += 1; //리스트 가져오기.
  },
  methods: {
    ...commonMapActions([commonActions.SET_DIALOG, commonActions.HIDE_DIALOG]),
    ...mapActions([
      shopTypes.SHOP_UNFOLLOW,
      shopTypes.SHOP_FOLLOW,
      shopTypes.FETCH_SHOP,
      shopTypes.FETCH_SHOPS,
    ]),
    ...estimateMapActions([estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]),
    ...chatMapActions([chatTypes.SEND_ESTIMATE_STORES]),
    // new
    async sendEstimation() {
      var sendData = {};

      console.log(this.storeId);

      if (this.storeId == '') {
        return;
      }

      this[commonActions.SET_DIALOG]({
        type: 'confirm',
        icon: 'warning',
        message: `요청서를 전송하시겠습니까?`,
        okCb: async () => {
          Object.assign(sendData, {
            estimateId: this.$route.query.estimateId,
            storeId: this.storeId,
          });

          console.log(sendData);
          await this[chatTypes.SEND_ESTIMATE_STORES](sendData);

          this.storeId = '';
          this.goHome();
        },
      });
    },
    isSaleEnd(store) {
      let now = new Date();
      var week = new Array('7', '1', '2', '3', '4', '5', '6'); // 일, 월, 화, 수, 목, 금, 토

      let hours = now.getHours(); // 시
      let minutes = now.getMinutes(); // 분

      var startTime = store.counselStart.split(':');
      var endTime = store.counselEnd.split(':');

      // console.log(hours);
      // console.log(startTime[0]);
      // console.log(endTime[0]);
      // console.log('store');
      // console.log(store);

      var isSaleChk = false;
      // 있음, 영업함
      if (store.counselDay.indexOf(week[now.getDay()]) !== -1) {
        // 시간 확인
        if (parseInt(startTime[0]) <= hours && parseInt(endTime[0]) >= hours) {
          if (parseInt(endTime[1]) < minutes && parseInt(endTime[0]) == hours) {
            isSaleChk = false;
          } else {
            isSaleChk = true;
          }
        } else {
          isSaleChk = false;
        }
      } else {
        isSaleChk = false;
      }
      return isSaleChk;
    },
    goHome() {
      this.$router.push({ name: 'Home' });
    },
    gotoEstimationManage() {
      this.$router.push({ name: 'Estimation.Manage' });
    },
    openShopFilterModal(type) {
      this.shopFilterModal = true;
    },
    handleEstimate() {
      this.$router.push({ name: 'Estimation.Form' }).catch(err => {});
    },
    gotoRegion() {
      let codeType = 'e';
      let areaId = this.user.emdAreaId;
      if (this.user.admName) {
        const admArea = JSON.parse(this.user.admName);
        areaId = admArea.id;
        codeType = 'a';
      }
      this.$router.push({
        name: 'Auth.RegionSelected',
        query: {
          //areaName: this.user.emdAreaName.split(' ')[2],
          areaName: this.user.emdAreaName.substring(
            this.user.emdAreaName.lastIndexOf(' ') + 1,
          ),
          areaFullName: this.user.emdAreaName,
          areaId,
          codeType,
          from: 'ShopList',
        },
      });
    },
    async getShopInfo(id) {
      //await this[shopTypes.FETCH_SHOPS](id);
    },

    closeShopFilterModal(orderType) {
      this.options.orderType = orderType;
      console.log('options ......');
      console.log(this.options);
      // if (this.options.keyword.id == 0) {
      //   delete options.keyword;
      // }
      this.filter = this.options;
      this.shopFilterModal = false;
      //this.getList();
      this.getListPageOne();
    },
    async getListPageOne() {
      this.direction = 'top';
      this.page = 1;
      this.infiniteId += 1;
    },
    async infiniteHandler($state) {
      if (this.infiniteId == 0) {
        $state.complete();
      } else {
        this.direction = 'bottom';
        await this.getList();

        if (this.page == 1) {
          this.list = [];
        }
        if (this.shops.content.length) {
          this.list.push(...this.shops.content);
          if (this.page == 1) {
            setTimeout(() => {
              this.$refs.dummy.scrollIntoView({ behavior: 'auto' });
              //window.scrollTo(0, 0);
            }, 10);
          }
          this.page += 1;
          $state.loaded();
        } else {
          $state.complete();
        }
      }
    },
    refresh() {
      this.filter = this.options;
      //this.getList();
      this.getListPageOne();
    },
    async getList() {
      let params = {
        orderType: this.filter.orderType,
        page: this.page,
        size: this.size,
      };
      if (this.filter.keyword) {
        params['keywordId'] = this.filter.keyword.id;
      }
      if (this.filter.follow) {
        params['follow'] = this.filter.follow;
      }
      await this[shopTypes.FETCH_SHOPS](params);
      this.fetchCompleted = true;
    },
    goShopDetail(shop) {
      this.$router.push({
        name: 'Shops.Detail',
        params: {
          id: shop.id,
        },
      });
    },
    // async toggleFollow(shop, id, idx) {
    //   const self = this;
    //   const funAutoEstimationInProgress = async () => {
    //     await self[estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]({
    //       userId: self.currentUser.id,
    //       storeId: id,
    //     });
    //   };
    //   const funToggle = async function() {
    //     await self[
    //       shop.followed ? shopTypes.SHOP_UNFOLLOW : shopTypes.SHOP_FOLLOW
    //     ]({ id: id });
    //     //self.refresh();
    //     //페이지 중간에 새로고침하면 문제가 되니 관심매장체크만 변경해줘야함.
    //     // console.log(self.list, idx);
    //     self.list[idx].followed = !self.list[idx].followed;
    //   };
    //   if (shop.followed) {
    //     // 자동견적서 체크.
    //     await funAutoEstimationInProgress();
    //     if (self.autoEstimation.id) {
    //       self[commonActions.SET_DIALOG]({
    //         type: 'confirm',
    //         icon: 'warning',
    //         //title: this.$t('common.confirm'),
    //         message:
    //           '관심매장 해지시 자동견적서 발송이 취소 됩니다. 해지 하시겠습니까?',
    //         okCb: async () => {
    //           await funToggle();
    //           //this.$router.go(-1);
    //         },
    //       });
    //     } else {
    //       await funToggle();
    //     }
    //   } else {
    //     await funToggle();
    //   }
    // },
    confirm() {},
  },
};
</script>
